<template>
  <div>
    <vue-ueditor-wrap
      ref="ueditor"
      v-model="content"
      :destroy="false"
      :config="config"
      @beforeInit="addCustomUI"
    ></vue-ueditor-wrap>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";

export default {
  props: {
    newContent: String,
  },
  data() {
    return {
      content: "",
      config: {
        autoHeightEnabled: true, // 编辑器不自动被内容撑高
        initialFrameHeight: 440, // 初始容器高度
        initialFrameWidth: "100%", // 初始容器宽度
        UEDITOR_HOME_URL: "/UEditor/",
        toolbars: [
          [
            "source", //源代码
            "undo", //撤销
            "redo", //重做
            "bold", //加粗
            "italic", //斜体
            "underline", //下划线
            "strikethrough", //删除线
            "subscript", //下标
            "superscript", //上标
            "fontborder", //字符边框
            "forecolor", //字体颜色
            "backcolor", //背景色
            "removeformat", //清除格式
            "paragraph", //段落格式
            "fontfamily", //字体
            "fontsize", //字号
            "justifyleft", //居左对齐
            "justifyright", //居右对齐
            "justifycenter", //居中对齐
            "justifyjustify", //两端对齐
            "link", //超链接
            "emotion", //表情
            "spechars", //特殊字符
            "horizontal", //分隔线
            "inserttable", //插入表格
            "mergeright", //右合并单元格
            "mergedown", //下合并单元格
            "deleterow", //删除行
            "deletecol", //删除列
            "splittorows", //拆分成行
            "splittocols", //拆分成列
            "splittocells", //完全拆分单元格
            "mergecells", //合并多个单元格
            "insertparagraphbeforetable", //"表格前插入行"
            "edittable", //表格属性
            "edittd", //单元格属性
            "template", //模板
            "autotypeset", //自动排版
            "print", //打印
            "preview", //预览
          ],
        ],
      },
    };
  },
 
  components: {
    VueUeditorWrap,
  },
  watch: {
    content(newVal, oldVal) {
      if (newVal != oldVal) {
        this.save();
      }
    },
    newContent(newVal) {
      this.content = newVal;
    },
  },
  methods: {
    // 传输内容
    save() {
      this.$emit("content", this.content);
    },
    // 编辑器设置
    addCustomUI(editorId, editorConfig) {
      let _this = this;
      // 1. 自定义按钮
      window.UE.registerUI(
        "test-button" + editorId,
        function (editor, uiName) {
          // 注册按钮执行时的 command 命令，使用命令默认就会带有回退操作
          // editor.registerCommand(uiName, {
          //   execCommand: function () {
          //     editor.execCommand(
          //       "inserthtml",
          //       `<span style="color: #${editorId.substr(
          //         -3
          //       )};">这是一段由自定义按钮添加的文字，你点击的编辑器ID是${editorId}</span>`
          //     );
          //   },
          // });
          // 创建一个 button
          var btn = new window.UE.ui.Button({
            // 按钮的名字
            name: uiName,
            // 提示
            title: "上传图片",
            // 需要添加的额外样式，可指定 icon 图标，图标路径参考常见问题 2
            cssRules:
              "background-image: url('/UEditor/themes/default/images/icons.png') !important;background-position: -726px -77px;",
            // 点击时执行的命令
            onclick: function () {
              // 这里可以不用执行命令，做你自己的操作也可
              // editor.execCommand(uiName);
              _this.$store.state.imgUsageType = 0;
              _this.$store.state.showBase = true;
            },
          });
          // 当点到编辑内容上时，按钮要做的状态反射
          // editor.addListener("selectionchange", function () {
          //   var state = editor.queryCommandState(uiName);
          //   if (state === -1) {
          //     btn.setDisabled(true);
          //     btn.setChecked(false);
          //   } else {
          //     btn.setDisabled(false);
          //     btn.setChecked(state);
          //   }
          // });
          // 因为你是添加 button，所以需要返回这个 button
          return btn;
        },
        40 /* 指定添加到工具栏上的哪个位置，默认时追加到最后 */,
        editorId /* 指定这个 UI 是哪个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮 */
      );
    },
  },
};
</script>

<style lang="less" scoped>
</style>